import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IOutOfStatePracticumSite } from 'app/models/training/out-of-state-practicum-site';
import { SharedService } from 'app/services/core/shared.service';
import { ITrainingProgram } from 'app/models/training/training-program';

@Component({
    selector: 'app-add-out-of-state-training-modal',
    templateUrl: './add-out-of-state-training-modal.component.html',
    styleUrls: ['./add-out-of-state-training-modal.component.scss'],
    standalone: false
})
export class AddOutOfStateTrainingModalComponent implements OnInit {

  public trainingForm = new UntypedFormGroup({
    trainingProgramName: new UntypedFormControl('', [Validators.required]),
    state: new UntypedFormControl('', [Validators.required]),
    licenseNumber: new UntypedFormControl('', [Validators.required, Validators.maxLength(100)])
  });

  public trainingPrograms: ITrainingProgram[] = [];
  public editMode: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddOutOfStateTrainingModalComponent>,
    public sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: {
      editMode?: boolean,
      existingProgram?: ITrainingProgram,
      existingSite?: IOutOfStatePracticumSite
    }
  ) {
    this.editMode = data.editMode || false;

    this.sharedService.loadAllowedStates();

    if (this.editMode && data.existingSite) {
      this.trainingForm.patchValue({
        state: data.existingSite.state,
        trainingProgramName: data.existingSite.trainingProgramName,
        licenseNumber: data.existingSite.licenseNumber
      });
      // Disable program selection in edit mode
      this.trainingForm.get('trainingProgramName').disable();
    }
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.trainingForm.valid || this.editMode) {
      const result: IOutOfStatePracticumSite = {
        id: this.editMode ? this.data.existingSite.id : 0,
        trainingProgramName: this.editMode ? this.data.existingSite.trainingProgramName : this.trainingForm.get('trainingProgramName').value,
        state: this.trainingForm.get('state').value,
        licenseNumber: this.trainingForm.get('licenseNumber').value,
        archived: false
      };
      this.dialogRef.close(result);
    }
  }
}
